import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';

export type EditorId = string;
export interface EditorIds { [key: string]: EditorId }

interface FirstSpiritApi {
  WE_API: {
    Preview: {
      rescan: (element: Element) => void;
    };
    Common: {
      getPreviewElement: () => unknown;
      showMessage: (text: string) => void;
      addPreviewElementListener: (listener: unknown) => void;
    };

  };
}

declare const top: FirstSpiritApi;

@Injectable({
  providedIn: 'root',
})
export class EditorIdService {

  private platformId = inject(PLATFORM_ID);

  public addEditorId(nativeElement: HTMLElement, editorId: string) {
    const attributes = editorId.split(' ');

    const editorIdAttributes: EditorIds = {};
    for (const attribute of attributes) {
      const keyValue = attribute.split('=');
      const key = keyValue[0];

      // Removes the first element (key) and joins the rest (value) because there could be an "=" in the value
      keyValue.splice(0, 1);
      const value = keyValue.join('=').slice(1, -1);

      editorIdAttributes[key] = value;
    }

    for (const attributeName in editorIdAttributes) {

      if (!Object.prototype.hasOwnProperty.call(editorIdAttributes, attributeName)) {
        continue;
      }

      nativeElement.setAttribute(attributeName, editorIdAttributes[attributeName]);
    }

    const firstSpiritApi = top;

    if (firstSpiritApi.WE_API !== undefined) {
      // This is some really hacky stuff to get webedit to work with angular...
      const clone = nativeElement.cloneNode() as HTMLElement;
      clone.style.display = 'none';
      document.body.appendChild(clone);

      firstSpiritApi.WE_API.Preview.rescan(clone);
      this.rescan(nativeElement);
    }
  }


  public rescan(nativeElement: Element) {
    if (isPlatformBrowser(this.platformId)) {
      const firstSpiritApi = top;
      if (firstSpiritApi.WE_API !== undefined) {
        firstSpiritApi.WE_API.Preview.rescan(nativeElement);
      }
    }

  }

}
